var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TextareaAutosize } from 'brg-react-resize-textarea';
import styled, { css } from 'styled-components';
import useCommonProps from '../../../../hooks/useCommonProps';
import { FontSizes } from '../../../../constants/theme';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT } from '../../../../constants/media';
import { convertMarkdownToHtml, sanitizeInput } from '../../../../utilites/sanitizeInput';
import { Input } from '@brg/input';
import { FlexBox } from '@brg/ui';
import { normalizeUrl } from '../utils/normalizeUrl';
import { updateCursorPosition } from '../utils/updaleCursorPosition';
import LinkIcon from '../../../icons/LinkIcon';
var SmoothTextArea = styled(TextareaAutosize)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  font-size: 42px;\n  line-height: 48px;\n  letter-spacing: -0.84px;\n  padding-right: 36px !important;\n  margin-bottom: 48px;\n  resize: none;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    font-size: inherit;\n    line-height: inherit;\n    ", "\n  }\n"], ["\n  width: 100%;\n  font-size: 42px;\n  line-height: 48px;\n  letter-spacing: -0.84px;\n  padding-right: 36px !important;\n  margin-bottom: 48px;\n  resize: none;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    font-size: inherit;\n    line-height: inherit;\n    ", "\n  }\n"])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (p) {
    return !p.type &&
        ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(p === null || p === void 0 ? void 0 : p.viewType)
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            font-size: ", "px !important;\n            line-height: ", "px !important;\n            letter-spacing: -0.02em;\n          "], ["\n            font-size: ", "px !important;\n            line-height: ", "px !important;\n            letter-spacing: -0.02em;\n          "])), (p === null || p === void 0 ? void 0 : p.postType) === 'normal'
            ? FontSizes.regularText.m.fs
            : FontSizes.bigText.m.fs, (p === null || p === void 0 ? void 0 : p.postType) === 'normal'
            ? FontSizes.regularText.m.lh
            : FontSizes.bigText.m.lh) : null;
});
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transition: height 0.8s ease-out;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 200px;\n"], ["\n  transition: height 0.8s ease-out;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 200px;\n"])));
var LinkFormWrapper = styled(FlexBox)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var LinkFormLabel = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: #909090;\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 133.333% */\n  letter-spacing: -0.3px;\n  width: 220px;\n"], ["\n  color: #909090;\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 133.333% */\n  letter-spacing: -0.3px;\n  width: 220px;\n"])));
var LinkInputWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background: #f2f2f2;\n  border-radius: 3px;\n  height: 48px;\n  width: 100%;\n\n  input {\n    background: rgba(21, 21, 20, 1);\n    border: 1px solid transparent;\n    border-radius: 3px;\n    outline: none;\n    letter-spacing: -0.02em;\n    width: 100%;\n    color: #bfbfbf;\n    font-family: Inter;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 133.333% */\n    letter-spacing: -0.3px;\n    &::placeholder {\n      color: #bfbfbf;\n    }\n    &:hover,\n    &:focus {\n      &::placeholder {\n        color: #bfbfbf;\n      }\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background: #f2f2f2;\n  border-radius: 3px;\n  height: 48px;\n  width: 100%;\n\n  input {\n    background: rgba(21, 21, 20, 1);\n    border: 1px solid transparent;\n    border-radius: 3px;\n    outline: none;\n    letter-spacing: -0.02em;\n    width: 100%;\n    color: #bfbfbf;\n    font-family: Inter;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 133.333% */\n    letter-spacing: -0.3px;\n    &::placeholder {\n      color: #bfbfbf;\n    }\n    &:hover,\n    &:focus {\n      &::placeholder {\n        color: #bfbfbf;\n      }\n    }\n  }\n"])));
var TextAreaIconWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var LinkIconWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n  bottom: 70px;\n  display: flex;\n  align-items: flex-end;\n  pointer-events: none;\n  z-index: 10;\n"], ["\n  position: absolute;\n  right: 8px;\n  bottom: 70px;\n  display: flex;\n  align-items: flex-end;\n  pointer-events: none;\n  z-index: 10;\n"])));
var LinkArea = function (_a) {
    var onResize = _a.onResize, type = _a.type, onChange = _a.onChange, value = _a.value, linkText = _a.linkText, onLinkChange = _a.onLinkChange, fontColor = _a.fontColor, bgcolor = _a.bgcolor, props = __rest(_a, ["onResize", "type", "onChange", "value", "linkText", "onLinkChange", "fontColor", "bgcolor"]);
    var container = useRef();
    var textarea = useRef();
    var linkIconRef = useRef();
    var linkRef = useRef();
    var _b = useState(''), link = _b[0], setLink = _b[1];
    var _c = useState({ top: 0, left: 0 }), cursorPosition = _c[0], setCursorPosition = _c[1];
    var _d = useState('input'), lastAction = _d[0], setLastAction = _d[1];
    var viewType = useCommonProps().viewType;
    var postType = useMemo(function () {
        var _a;
        return ((_a = ['normal', 'normal_image', 'normal_card', 'normal_emblem']) === null || _a === void 0 ? void 0 : _a.includes(props.postType))
            ? 'normal'
            : props === null || props === void 0 ? void 0 : props.postType;
    }, [props]);
    var handleResize = function (e) {
        container.current.style.height = "".concat(e.target.offsetHeight + 62, "px");
        e.target.scrollTo(0, 0);
        if (onResize) {
            onResize(e);
        }
    };
    var updateIconPosition = function (mode) {
        if (mode === void 0) { mode = 'input'; }
        if (!textarea.current)
            return;
        var el = textarea.current;
        var prevStart = el.selectionStart;
        var prevEnd = el.selectionEnd;
        el.selectionStart = el.value.length;
        el.selectionEnd = el.value.length;
        updateCursorPosition(textarea, linkIconRef, setCursorPosition);
        el.selectionStart = prevStart;
        el.selectionEnd = prevEnd;
    };
    var handleChange = function (e) {
        setLastAction('input');
        if (onChange) {
            var markdownValue = convertMarkdownToHtml(e.target.value);
            var cleanedValue = sanitizeInput(markdownValue);
            e.target.value = cleanedValue;
            onChange(e);
        }
        updateIconPosition();
    };
    var handleMouseUp = function (e) {
        setLastAction('input');
        updateIconPosition();
    };
    var handleKeyUp = function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            setLastAction('arrow');
            updateIconPosition('arrow');
        }
        else {
            setLastAction('input');
            updateIconPosition('input');
        }
    };
    var handleTextareaClick = function (e) {
        e.stopPropagation();
        if (textarea.current) {
            textarea.current.focus();
        }
        setLastAction('input');
        updateIconPosition('input');
    };
    var handleInputClick = function (e) {
        e.stopPropagation();
        if (linkRef.current) {
            linkRef.current.focus();
        }
    };
    useEffect(function () {
        if (!container.current || !textarea.current)
            return;
        container.current.style.height = "".concat(textarea.current.offsetHeight + 62, "px");
        setLink(linkText);
    }, []);
    var handleLinkChange = function (_a) {
        var value = _a.target.value;
        setLink(value);
    };
    useEffect(function () {
        onLinkChange(normalizeUrl(link));
    }, [link]);
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };
    useEffect(function () {
        if (typeof window === 'undefined')
            return;
        updateIconPosition('input');
        var textareaEl = textarea.current;
        if (!textareaEl)
            return;
        textareaEl.addEventListener('keyup', handleKeyUp);
        return function () {
            textareaEl.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { ref: container, className: 'textarea-wrapper', style: { position: 'relative' }, onClick: handleTextareaClick },
            React.createElement(TextAreaIconWrapper, null,
                React.createElement(SmoothTextArea, __assign({ ref: textarea, type: type, value: value }, props, { postType: postType, viewType: viewType, onResize: handleResize, onChange: handleChange, onKeyUp: handleKeyUp, onKeyDown: handleKeyDown, onMouseUp: handleMouseUp, rows: 1, maxLength: 70 })),
                !!(value === null || value === void 0 ? void 0 : value.length) && (React.createElement(LinkIconWrapper, { ref: linkIconRef, style: {
                        top: cursorPosition.top,
                        left: cursorPosition.left + 10
                    } },
                    React.createElement(LinkIcon, { fontColor: fontColor })))),
            React.createElement(LinkFormWrapper, { gx: 24 },
                React.createElement(LinkFormLabel, { style: { color: fontColor } }, 'Ссылка'),
                React.createElement(LinkInputWrapper, { onClick: handleInputClick },
                    React.createElement(Input.Text, { ref: linkRef, value: link, onChange: handleLinkChange, placeholder: 'Вставьте ссылку' }))))));
};
export default LinkArea;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=LinkArea.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TextareaAutosize } from 'brg-react-resize-textarea';
import styled, { css } from 'styled-components';
import useCommonProps from '../../../../hooks/useCommonProps';
import { FontSizes } from '../../../../constants/theme';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT } from '../../../../constants/media';
import { convertMarkdownToHtml, sanitizeInput } from '../../../../utilites/sanitizeInput';
import { Input } from '@brg/input';
import { FlexBox } from '@brg/ui';
import { normalizeUrl } from '../utils/normalizeUrl';
import { updateCursorPosition } from '../utils/updaleCursorPosition';
import LinkIcon from '../../../icons/LinkIcon';
var SmoothTextArea = styled(TextareaAutosize)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  font-size: 42px;\n  line-height: 48px;\n  letter-spacing: -0.84px;\n  padding-right: 36px !important;\n  margin-bottom: 48px;\n  resize: none;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    font-size: inherit;\n    line-height: inherit;\n    ", "\n  }\n"], ["\n  width: 100%;\n  font-size: 42px;\n  line-height: 48px;\n  letter-spacing: -0.84px;\n  padding-right: 36px !important;\n  margin-bottom: 48px;\n  resize: none;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    font-size: inherit;\n    line-height: inherit;\n    ", "\n  }\n"])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (p) {
    return !p.type &&
        ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(p === null || p === void 0 ? void 0 : p.viewType)
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            font-size: ", "px !important;\n            line-height: ", "px !important;\n            letter-spacing: -0.02em;\n          "], ["\n            font-size: ", "px !important;\n            line-height: ", "px !important;\n            letter-spacing: -0.02em;\n          "])), (p === null || p === void 0 ? void 0 : p.postType) === 'normal'
            ? FontSizes.regularText.m.fs
            : FontSizes.bigText.m.fs, (p === null || p === void 0 ? void 0 : p.postType) === 'normal'
            ? FontSizes.regularText.m.lh
            : FontSizes.bigText.m.lh) : null;
});
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transition: height 0.8s ease-out;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 200px;\n"], ["\n  transition: height 0.8s ease-out;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 200px;\n"])));
var LinkFormWrapper = styled(FlexBox)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var LinkFormLabel = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: #909090;\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 133.333% */\n  letter-spacing: -0.3px;\n  width: 220px;\n"], ["\n  color: #909090;\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 133.333% */\n  letter-spacing: -0.3px;\n  width: 220px;\n"])));
var LinkInputWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background: #f2f2f2;\n  border-radius: 3px;\n  height: 48px;\n  width: 100%;\n\n  input {\n    background: rgba(21, 21, 20, 1);\n    border: 1px solid transparent;\n    border-radius: 3px;\n    outline: none;\n    letter-spacing: -0.02em;\n    width: 100%;\n    color: #bfbfbf;\n    font-family: Inter;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 133.333% */\n    letter-spacing: -0.3px;\n    &::placeholder {\n      color: #bfbfbf;\n    }\n    &:hover,\n    &:focus {\n      &::placeholder {\n        color: #bfbfbf;\n      }\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background: #f2f2f2;\n  border-radius: 3px;\n  height: 48px;\n  width: 100%;\n\n  input {\n    background: rgba(21, 21, 20, 1);\n    border: 1px solid transparent;\n    border-radius: 3px;\n    outline: none;\n    letter-spacing: -0.02em;\n    width: 100%;\n    color: #bfbfbf;\n    font-family: Inter;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 133.333% */\n    letter-spacing: -0.3px;\n    &::placeholder {\n      color: #bfbfbf;\n    }\n    &:hover,\n    &:focus {\n      &::placeholder {\n        color: #bfbfbf;\n      }\n    }\n  }\n"])));
var TextAreaIconWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var LinkIconWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n  bottom: 70px;\n  display: flex;\n  align-items: flex-end;\n  pointer-events: none;\n  z-index: 10;\n"], ["\n  position: absolute;\n  right: 8px;\n  bottom: 70px;\n  display: flex;\n  align-items: flex-end;\n  pointer-events: none;\n  z-index: 10;\n"])));
var LinkArea = function (_a) {
    var onResize = _a.onResize, type = _a.type, onChange = _a.onChange, value = _a.value, linkText = _a.linkText, onLinkChange = _a.onLinkChange, fontColor = _a.fontColor, bgcolor = _a.bgcolor, props = __rest(_a, ["onResize", "type", "onChange", "value", "linkText", "onLinkChange", "fontColor", "bgcolor"]);
    var container = useRef();
    var textarea = useRef();
    var linkIconRef = useRef();
    var linkRef = useRef();
    var _b = useState(''), link = _b[0], setLink = _b[1];
    var _c = useState({ top: 0, left: 0 }), cursorPosition = _c[0], setCursorPosition = _c[1];
    var _d = useState('input'), lastAction = _d[0], setLastAction = _d[1];
    var viewType = useCommonProps().viewType;
    var postType = useMemo(function () {
        var _a;
        return ((_a = ['normal', 'normal_image', 'normal_card', 'normal_emblem']) === null || _a === void 0 ? void 0 : _a.includes(props.postType))
            ? 'normal'
            : props === null || props === void 0 ? void 0 : props.postType;
    }, [props]);
    var handleResize = function (e) {
        container.current.style.height = "".concat(e.target.offsetHeight + 62, "px");
        e.target.scrollTo(0, 0);
        if (onResize) {
            onResize(e);
        }
    };
    var updateIconPosition = function (mode) {
        if (mode === void 0) { mode = 'input'; }
        if (!textarea.current)
            return;
        var el = textarea.current;
        var prevStart = el.selectionStart;
        var prevEnd = el.selectionEnd;
        el.selectionStart = el.value.length;
        el.selectionEnd = el.value.length;
        updateCursorPosition(textarea, linkIconRef, setCursorPosition);
        el.selectionStart = prevStart;
        el.selectionEnd = prevEnd;
    };
    var handleChange = function (e) {
        setLastAction('input');
        if (onChange) {
            var markdownValue = convertMarkdownToHtml(e.target.value);
            var cleanedValue = sanitizeInput(markdownValue);
            e.target.value = cleanedValue;
            onChange(e);
        }
        updateIconPosition();
    };
    var handleMouseUp = function (e) {
        setLastAction('input');
        updateIconPosition();
    };
    var handleKeyUp = function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            setLastAction('arrow');
            updateIconPosition('arrow');
        }
        else {
            setLastAction('input');
            updateIconPosition('input');
        }
    };
    var handleTextareaClick = function (e) {
        e.stopPropagation();
        if (textarea.current) {
            textarea.current.focus();
        }
        setLastAction('input');
        updateIconPosition('input');
    };
    var handleInputClick = function (e) {
        e.stopPropagation();
        if (linkRef.current) {
            linkRef.current.focus();
        }
    };
    useEffect(function () {
        if (!container.current || !textarea.current)
            return;
        container.current.style.height = "".concat(textarea.current.offsetHeight + 62, "px");
        setLink(linkText);
    }, []);
    var handleLinkChange = function (_a) {
        var value = _a.target.value;
        setLink(value);
    };
    useEffect(function () {
        onLinkChange(normalizeUrl(link));
    }, [link]);
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };
    useEffect(function () {
        if (typeof window === 'undefined')
            return;
        updateIconPosition('input');
        var textareaEl = textarea.current;
        if (!textareaEl)
            return;
        textareaEl.addEventListener('keyup', handleKeyUp);
        return function () {
            textareaEl.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { ref: container, className: 'textarea-wrapper', style: { position: 'relative' }, onClick: handleTextareaClick },
            React.createElement(TextAreaIconWrapper, null,
                React.createElement(SmoothTextArea, __assign({ ref: textarea, type: type, value: value }, props, { postType: postType, viewType: viewType, onResize: handleResize, onChange: handleChange, onKeyUp: handleKeyUp, onKeyDown: handleKeyDown, onMouseUp: handleMouseUp, rows: 1, maxLength: 70 })),
                !!(value === null || value === void 0 ? void 0 : value.length) && (React.createElement(LinkIconWrapper, { ref: linkIconRef, style: {
                        top: cursorPosition.top,
                        left: cursorPosition.left + 10
                    } },
                    React.createElement(LinkIcon, { fontColor: fontColor })))),
            React.createElement(LinkFormWrapper, { gx: 24 },
                React.createElement(LinkFormLabel, { style: { color: fontColor } }, 'Ссылка'),
                React.createElement(LinkInputWrapper, { onClick: handleInputClick },
                    React.createElement(Input.Text, { ref: linkRef, value: link, onChange: handleLinkChange, placeholder: 'Вставьте ссылку' }))))));
};
export default LinkArea;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=LinkArea.js.map